import React from 'react'

const Error404 = () => {
  return (
    <h2>Error404</h2>
  )
}

export default Error404